import SearchableSelect from "../../../../components/SearchableSelect";

export default function PlatformPricing() {
  return (<>
      <section className="section-space pricing-section" id="pricing">
        <div className="container">
          <div className="section-heading centered reveal">
            <div className="eyebrow">{"PRICING"}</div>
            <h2>{"Start small. Pay for what you use. Scale when it works."}</h2>
            <p>{"Use different pricing models for software, managed services and transaction-based products."}</p>
          </div>

          <div className="pricing-tabs" role="tablist">
            <button className="pricing-tab active" data-pricing="software">{"Software"}</button>
            <button className="pricing-tab" data-pricing="managed">{"Managed Services"}</button>
            <button className="pricing-tab" data-pricing="usage">{"Usage"}</button>
          </div>

          <div className="pricing-panel active" id="pricing-software">
            <div className="price-grid">
              <div className="price-card reveal"><small>{"STARTER"}</small><h3>{"$19"}<span>{"/mo"}</span></h3><p>{"For small teams starting digital operations."}</p><ul><li>{"Core dashboard"}</li><li>{"1 business app"}</li><li>{"Email support"}</li><li>{"Basic analytics"}</li></ul><a className="btn btn-ghost full" href="#contact">{"Start Starter"}</a></div>
              <div className="price-card featured reveal delay-1"><div className="popular">{"MOST FLEXIBLE"}</div><small>{"BUSINESS"}</small><h3>{"$99"}<span>{"/mo"}</span></h3><p>{"For growing businesses using multiple modules."}</p><ul><li>{"Multiple modules"}</li><li>{"API access"}</li><li>{"Priority support"}</li><li>{"Advanced reporting"}</li></ul><a className="btn btn-primary full" href="#contact">{"Start Business"}</a></div>
              <div className="price-card reveal delay-2"><small>{"SCALE"}</small><h3>{"$299"}<span>{"/mo"}</span></h3><p>{"For businesses needing control and integrations."}</p><ul><li>{"Advanced integrations"}</li><li>{"Role management"}</li><li>{"Automation"}</li><li>{"Priority operations"}</li></ul><a className="btn btn-ghost full" href="#contact">{"Start Scale"}</a></div>
              <div className="price-card reveal delay-3"><small>{"ENTERPRISE"}</small><h3>{"Custom"}</h3><p>{"For complex requirements, SLA and deployment needs."}</p><ul><li>{"Custom architecture"}</li><li>{"Dedicated support"}</li><li>{"Enterprise controls"}</li><li>{"Commercial SLA"}</li></ul><a className="btn btn-dark full" href="#contact">{"Contact Sales"}</a></div>
            </div>
          </div>

          <div className="pricing-panel" id="pricing-managed">
            <div className="calculator-wrap">
              <div>
                <h3>{"Managed service estimator"}</h3>
                <p>{"Adjust the inputs to create a simple planning estimate."}</p>
                <div className="calc-form">
                  <label>{"Service"}<SearchableSelect id="managedService"><option value="99">{"Managed DevOps"}</option><option value="199">{"Managed Development"}</option><option value="99">{"Managed QA"}</option><option value="149">{"Managed Security"}</option><option value="99">{"Managed Customer Support"}</option></SearchableSelect></label>
                  <label>{"Hours / month"}<input type="range" id="hoursRange" min="10" max="160" step="10" defaultValue="40" /><span id="hoursValue">{"40 hours"}</span></label>
                  <label>{"Coverage"}<SearchableSelect id="coverageFactor"><option value="1">{"Business hours"}</option><option value="1.35">{"Extended hours"}</option><option value="1.75">{"24/7 coverage"}</option></SearchableSelect></label>
                  <label>{"SLA"}<SearchableSelect id="slaFactor"><option value="1">{"Standard"}</option><option value="1.2">{"Priority"}</option><option value="1.45">{"Critical"}</option></SearchableSelect></label>
                </div>
              </div>
              <div className="estimate-card">
                <small>{"ESTIMATED MONTHLY START"}</small>
                <strong id="estimatePrice">{"$396"}</strong>
                <p>{"Planning estimate only. Actual pricing depends on scope, complexity, location and service design."}</p>
                <a href="#contact" className="btn btn-primary full">{"Get Exact Quote"}</a>
              </div>
            </div>
          </div>

          <div className="pricing-panel" id="pricing-usage">
            <div className="usage-grid">
              <div><span>{"QR"}</span><strong>{"Usage based"}</strong><p>{"Country and provider dependent."}</p></div>
              <div><span>{"Checkout"}</span><strong>{"Usage based"}</strong><p>{"Configured by market and integration."}</p></div>
              <div><span>{"Bill Payment"}</span><strong>{"Usage based"}</strong><p>{"Commercials vary by channel."}</p></div>
              <div><span>{"WhatsApp"}</span><strong>{"Usage based"}</strong><p>{"Messaging and AI usage can be metered."}</p></div>
              <div><span>{"APIs"}</span><strong>{"Usage based"}</strong><p>{"Volume bands can be configured."}</p></div>
              <div><span>{"Reconciliation"}</span><strong>{"Usage based"}</strong><p>{"Based on records, transactions or accounts."}</p></div>
            </div>
          </div>
        </div>
      </section>

      <section className="section-space resources-section" id="resources">
        <div className="container">
          <div className="section-heading reveal">
            <div className="eyebrow">{"RESOURCES"}</div>
            <h2>{"Give technical and business teams what they need."}</h2>
          </div>
          <div className="resource-grid">
            <a href="#"><span>{"DOCS"}</span><h3>{"Documentation"}</h3><p>{"Implementation and product guides."}</p></a>
            <a href="#"><span>{"API"}</span><h3>{"API Reference"}</h3><p>{"Endpoints, payloads and examples."}</p></a>
            <a href="#"><span>{"HELP"}</span><h3>{"Knowledge Base"}</h3><p>{"Product and operational support."}</p></a>
            <a href="#"><span>{"STATUS"}</span><h3>{"System Status"}</h3><p>{"Service health and incident updates."}</p></a>
          </div>
        </div>
      </section>

  </>);
}
